/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.getSession'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  active: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  didDoc: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
  handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['takendown', 'suspended', 'deactivated']
    }>(),
  ),
  emailConfirmed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  emailAuthFactor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get information about the current auth session. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
